/**
 * @generated SignedSource<<0a72f71eca3d6ebb65acafb740eeb9ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CustomerParentComponentQuery$variables = {};
export type CustomerParentComponentQuery$data = {
  readonly getCustomerList: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly getDistributors: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type CustomerParentComponentQuery = {
  response: CustomerParentComponentQuery$data;
  variables: CustomerParentComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomerObjectType",
    "kind": "LinkedField",
    "name": "getCustomerList",
    "plural": true,
    "selections": (v0/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DistributorObjectType",
    "kind": "LinkedField",
    "name": "getDistributors",
    "plural": true,
    "selections": (v0/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerParentComponentQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CustomerParentComponentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c74231172a4c0617e4ab7e172f33d043",
    "id": null,
    "metadata": {},
    "name": "CustomerParentComponentQuery",
    "operationKind": "query",
    "text": "query CustomerParentComponentQuery {\n  getCustomerList {\n    id\n    name\n  }\n  getDistributors {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ab656c117781e68a324bd5a95667ca3";

export default node;
